var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 2.91602C6.59768 2.91602 3.41797 6.09572 3.41797 9.99935C3.41797 13.903 6.59768 17.0827 10.5013 17.0827C14.4049 17.0827 17.5846 13.903 17.5846 9.99935C17.5846 6.09572 14.4049 2.91602 10.5013 2.91602ZM10.5013 4.33268C13.6393 4.33268 16.168 6.86135 16.168 9.99935C16.168 13.1374 13.6393 15.666 10.5013 15.666C7.3633 15.666 4.83464 13.1374 4.83464 9.99935C4.83464 6.86135 7.3633 4.33268 10.5013 4.33268Z",
    fill: "url(#paint0_linear_6079_444180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 6.4574C10.3134 6.4574 10.1333 6.53204 10.0004 6.66488C9.8676 6.79772 9.79297 6.97787 9.79297 7.16573V9.29073H7.66797C7.48011 9.29073 7.29994 9.36537 7.1671 9.49821C7.03426 9.63105 6.95964 9.81121 6.95964 9.99907C6.95964 10.1869 7.03426 10.3671 7.1671 10.4999C7.29994 10.6328 7.48011 10.7074 7.66797 10.7074H9.79297V12.8324C9.79297 13.0203 9.8676 13.2004 10.0004 13.3333C10.1333 13.4661 10.3134 13.5407 10.5013 13.5407C10.6892 13.5407 10.8693 13.4661 11.0022 13.3333C11.135 13.2004 11.2096 13.0203 11.2096 12.8324V10.7074H13.3346C13.5225 10.7074 13.7027 10.6328 13.8355 10.4999C13.9683 10.3671 14.043 10.1869 14.043 9.99907C14.043 9.81121 13.9683 9.63105 13.8355 9.49821C13.7027 9.36537 13.5225 9.29073 13.3346 9.29073H11.2096V7.16573C11.2096 6.97787 11.135 6.79772 11.0022 6.66488C10.8693 6.53204 10.6892 6.4574 10.5013 6.4574Z",
    fill: "url(#paint1_linear_6079_444180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6079_444180",
    x1: 2.38139,
    y1: -1.81473,
    x2: 21.4455,
    y2: -0.753042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6079_444180",
    x1: 2.38139,
    y1: -1.81473,
    x2: 21.4455,
    y2: -0.753042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOutlined);
export default __webpack_public_path__ + "static/media/plus_outlined.3c6e26f5dd1a98cca35967dd2127ffcd.svg";
export { ForwardRef as ReactComponent };